var findCoreSelector = document.querySelector('select.t4s-product__select');
const getKentekenFields = document.querySelectorAll('.centeredkenteken');

const unsupportedRules = {
    excludeBrands: [
        'kia', 'renault', 'opel', 'daihatsu', 'subaru',
        'dacia', 'honda', 'eura mobil', 'suzuki', 'hyundai',
        'mitsubishi', 'hymer'
    ],
    excludeByYear: {}
};

var htmlComplete = `
<div class="custom-modal--background"></div>
    <div class="custom-modal--wrapper">
        <div class="custom-modal--close"></div>
        <div class="custom-modal--inner">
            <h2>Car found</h2>
            <div class="custom-modal--content">
                <p>Your car is fully supported. After installation, you'll enjoy CarPlay and Android Auto right away</p>
                <mark data-state="warning">Before placing your order, please verify all selected options carefully.</mark>
            </div>
            <div class="custom-modal--cta">
                <button>Close</button>
            </div>
        </div>
    </div>`;

var htmlFail = `
<div class="custom-modal--background"></div>
    <div class="custom-modal--wrapper">
        <div class="custom-modal--close"></div>
        <div class="custom-modal--inner">
            <h2>More details required</h2>
            <div class="custom-modal--content">
                <p>WhatsApp or email us for personalized advice</p>
            </div>
            <div class="custom-modal--send-message">
              <div class="custom-modal--send-message--wrapper">
                <textarea>Dear CarOptions, I'm interested in a CarPlayBox for my car. I look forward to your recommendation.</textarea>
                <div class="custom-modal--send-message--buttons">
                  <div class="btn btn-whatsapp">
                    <i></i>
                    <span>Send WhatsApp</span>
                  </div>
                  <a href="mailto:support@caroptions.com?subject=Advies%20CarPlayBox&amp;body=Beste%20CarOptions%20ik%20heb%20interesse%20in%20een%20CarPlayBox%20voor%20mijn%20auto.%20Ik%20zie%20graag%20een%20advies%20tegemoet.
" class="btn btn-mail">
                    <i></i>
                    <span>Send email</span>
                  </a>
                </div>
              </div>
            </div>
              <div class="custom-modal--brands">
                  <header>Or search manually:</header>
                  <div class="custom-modal--brands--list">
                      <a href="https://www.caroptions.nl/products/carplaybox-volkswagen">
                          <img src="https://cdn.shopify.com/s/files/1/0727/7477/9171/files/vw_965113a2-d049-4814-9711-0c59f97247c0.png?v=1687983423" alt="Volkwagen" title="Volkwagen">
                      </a>
                      <a href="https://www.caroptions.nl/products/carplaybox-porsche">
                          <img src="https://cdn.shopify.com/s/files/1/0727/7477/9171/files/porsche_1bc20035-ea19-4fee-8857-eeb9cf4f5cd2.png?v=1687983488" alt="Porsche" title="Porsche">
                      </a>
                      <a href="https://www.caroptions.nl/products/carplaybox-mini">
                          <img src="https://cdn.shopify.com/s/files/1/0727/7477/9171/files/mini_1d29cba7-7130-4858-99a5-e73c3f263380.png?v=1687983821" alt="Mini" title="Mini">
                      </a>
                      <a href="https://www.caroptions.nl/products/carplaybox-bmw">
                          <img src="https://cdn.shopify.com/s/files/1/0727/7477/9171/files/bmw_3b484f3e-b08d-4c60-8cb6-a5ddee37ab1e.png?v=1687983837" alt="BMW" title="BMW">
                      </a>
                      <a href="https://www.caroptions.nl/products/carplaybox-mercedes">
                          <img src="https://cdn.shopify.com/s/files/1/0727/7477/9171/files/merc_04dfdc7e-91a5-4ace-ad3a-f8c43002594b.png?v=1687983853" alt="Mercedes" title="Mercedes">
                      </a>
                      <a href="https://www.caroptions.nl/products/carplaybox-audi">
                          <img src="https://cdn.shopify.com/s/files/1/0727/7477/9171/files/audi_d358cdbb-e243-44c8-98ff-da73bf4f226c.png?v=1687983866" alt="Audi" title="Audi">
                      </a>
                      <a href="https://www.caroptions.nl/products/carplaybox-seat">
                          <img src="https://cdn.shopify.com/s/files/1/0727/7477/9171/files/seat_2af06407-6ea7-4e71-aa48-c8f831627fe8.png?v=1687983878" alt="Seat" title="Seat">
                      </a>
                      <a href="https://www.caroptions.nl/products/carplay-android-auto-voor-mazda">
                          <img src="https://cdn.shopify.com/s/files/1/0727/7477/9171/files/mazdalogo.png?v=1731281733" alt="Mazda" title="Mazda">
                      </a>
                      <a href="https://www.caroptions.nl/products/carplaybox-citroen">
                          <img src="https://cdn.shopify.com/s/files/1/0727/7477/9171/files/Untitled-2.png?v=1726684532" alt="Citroën" title="Citroën">
                      </a>
                      <a href="https://www.caroptions.nl/products/carplaybox-bentley">
                          <img src="https://cdn.shopify.com/s/files/1/0727/7477/9171/files/logo_dca11a99-3d13-404d-b77b-de98b11a81b4.png?v=1698241023" alt="Bentley" title="Bentley">
                      </a>
                      <a href="https://www.caroptions.nl/products/carplaybox-ford">
                          <img src="https://cdn.shopify.com/s/files/1/0727/7477/9171/files/ford.png?v=1750123423" alt="Ford" title="Ford">
                      </a>
                      <a href="https://www.caroptions.nl/products/carplaybox-volvo">
                          <img src="https://cdn.shopify.com/s/files/1/0727/7477/9171/files/volvo_acb51cd1-e86d-4e8e-ad3f-5e5a45f112d6.png?v=1687983895" alt="Volvo" title="Volvo">
                      </a>
                      <a href="https://www.caroptions.nl/products/carplaybox-skoda">
                          <img src="https://cdn.shopify.com/s/files/1/0727/7477/9171/files/skoda_a013c339-5289-48b1-abfd-35498dbd4c2f.png?v=1687983911" alt="Skoda" title="Skoda">
                      </a>
                      <a href="https://www.caroptions.nl/products/carplaybox-lexus">
                          <img src="https://cdn.shopify.com/s/files/1/0727/7477/9171/files/lexus_266491af-f5a4-46eb-b43d-dfe7168ca1f3.png?v=1687983923" alt="Lexus" title="Lexus">
                      </a>
                      <a href="https://www.caroptions.nl/products/carplaybox-tesla">
                          <img src="https://cdn.shopify.com/s/files/1/0727/7477/9171/files/t-brand.png?v=1760260033" alt="Tesla" title="Tesla">
                      </a>
                      <a href="https://www.caroptions.nl/products/carplaybox-rolls-royce">
                          <img src="https://cdn.shopify.com/s/files/1/0727/7477/9171/files/logo_ef3ae425-3c9d-4b0f-a9c9-a3367e2569ae.png?v=1698232682" alt="Rolls Royce" title="Rolls Royce">
                      </a>
                      <a href="https://www.caroptions.nl/products/carplaybox-alfa-romeo">
                          <img src="https://cdn.shopify.com/s/files/1/0727/7477/9171/files/alfa.png?v=1698234153" alt="Alfa Romeo" title="Alfa Romeo">
                      </a>
                      <a href="https://www.caroptions.nl/products/carplaybox-land-rover">
                          <img src="https://cdn.shopify.com/s/files/1/0727/7477/9171/files/landrover.png?v=1698234605" alt="Land Rover" title="Land Rover">
                      </a>
                      <a href="https://www.caroptions.nl/products/carplaybox-toyota">
                          <img src="https://cdn.shopify.com/s/files/1/0727/7477/9171/files/logo_15cefb29-65e1-41e9-a3f3-ee1ae6f65b0b.png?v=1731288072" alt="Toyota" title="Toyota">
                      </a>
                      <a href="https://www.caroptions.nl/products/carplaybox-dodge">
                          <img src="https://cdn.shopify.com/s/files/1/0727/7477/9171/files/logo_f4af9ecc-08fb-4245-b1ab-d7dca433405e.png?v=1731894271" alt="Dodge" title="Dodge">
                      </a>
                      <a href="https://www.caroptions.nl/products/carplaybox-peugeot">
                          <img src="https://cdn.shopify.com/s/files/1/0727/7477/9171/files/logo_e039c09d-af90-481f-b16b-e519fec5b6ce.png?v=1732719300" alt="Peugeot" title="Peugeot">
                      </a>
                      <a href="https://www.caroptions.nl/products/carplaybox-jaguar">
                          <img src="https://cdn.shopify.com/s/files/1/0727/7477/9171/files/logo_5087afb9-662a-445f-bc84-c77ea3306a7f.png?v=1732841454" alt="Jaguar" title="Jaguar">
                      </a>
                  </div>
              </div>
        </div>
    </div>`;

const generateUnsupportedHTML = (merk, bouwjaar = '') => {
    merk = merk?.toUpperCase();
    bouwjaar = bouwjaar?.split('-')[0];
    const lowerMerk = merk.toLowerCase();
    const excluded = unsupportedRules.excludeBrands.includes(lowerMerk);
    const yearLimit = unsupportedRules.excludeByYear[lowerMerk];

    let message = '';
    if (excluded) {
        message = `Unfortunately, we currently do not offer a compatible CarPlay or Android Auto solution for ${merk}. There is no compatible product available for this vehicle type at this time.
        </br>
        </br>
        We are continuously expanding our support. Your car may be supported in the future, so feel free to check back later.`;
    } else if (yearLimit && bouwjaar) {
        const limit = parseInt(yearLimit);
        message = `For ${merk} vehicles manufactured before ${limit + 1}, we currently do not offer CarPlay and Android Auto support.
        </br></br>
        We regularly expand our product range. Your vehicle may be supported in the near future. Stay tuned via our website and social media!`;
    } else {
        message = `${merk} is currently not supported.`;
    }

    return `
    <div class="custom-modal--background"></div>
        <div class="custom-modal--wrapper">
            <div class="custom-modal--close"></div>
            <div class="custom-modal--inner">
                <h2>Not supported</h2>
                <div class="custom-modal--content">
                    <p>${message}</p>
                </div>
                <div class="custom-modal--cta">
                    <button>Close</button>
                </div>
            </div>
        </div>`;
}

const htmlFailFunctions = (_data, _kenteken) => {
    const modalMessageWrapper = document.querySelector('.custom-modal--send-message--wrapper');
    const mailButton = document.querySelector('.btn-mail');
    const whatsappButton = document.querySelector('.btn-whatsapp');
    const textArea = document.querySelector('textarea');
    let theData = {};
    if (!modalMessageWrapper || !mailButton || !whatsappButton || !textArea) return;

    if (_data) {
        theData = {
            merk: _data.merk || '...',
            type: _data.handelsbenaming || _data.type || '',
            bouwjaar: _data.datum_eerste_toelating || _data.bouwjaar || ''
        };

        textArea.value = `Dear CarOptions, I'm interested in a CarPlayBox for my car. I look forward to your recommendation.`
        let message = '';

        if (theData.merk) {
            message = encodeURIComponent(`${textArea.value} - ${theData.merk} ${theData.type} ${theData.bouwjaar} with license plate: ${_kenteken ? _kenteken : '...'}`);
        } else {
            message = encodeURIComponent(textArea.value);
        }

        const newMailTo = `mailto:support@caroptions.com?subject=Advies%20CarPlayBox&body=${message}`;
        mailButton.setAttribute('href', newMailTo);
    }

    // Update de mailto href wanneer de tekst in de textarea verandert
    textArea.addEventListener('input', function() {
        let message = '';

        if (theData.merk) {
            message = encodeURIComponent(`${textArea.value} - ${theData.merk} ${theData.type} ${theData.bouwjaar} with license plate: ${_kenteken ? _kenteken : '...'}`);
        } else {
            message = encodeURIComponent(textArea.value);
        }
        const newMailTo = `mailto:support@caroptions.com?subject=Advies%20CarPlayBox&body=${message}`;
        mailButton.setAttribute('href', newMailTo);
    });

    // Open WhatsApp wanneer er op de WhatsApp-knop wordt geklikt
    whatsappButton.addEventListener('click', function() {
        const nr = '31850606177';
        let message = '';

        if (theData.merk) {
            message = encodeURIComponent(`${textArea.value} - ${theData.merk} ${theData.type} ${theData.bouwjaar} with license plate: ${_kenteken ? _kenteken : '...'}`);
        } else {
            message = encodeURIComponent(textArea.value);
        }
        const url = `https://api.whatsapp.com/send/?phone=${nr}&text=${message}%0A%0A&type=phone_number&app_absent=0`;
        window.open(url, '_blank');
    });
};

const activatePopUp = _html => {
    const checkActiveModal = document.querySelector('.custom-modal');

    if (_html === "carfinder") {
        const carFinderModal = document.querySelector('.carfinder_modal');
        if (carFinderModal) {
            carFinderModal.style.display = 'block';
            document.body.classList.add('carfinder-open');
        }
    } else if (!checkActiveModal) {
        const newModal = document.createElement('div');
        newModal.classList.add('custom-modal');
        newModal.innerHTML = _html;
        document.body.appendChild(newModal);

        // Link functions
        const modalCloseButton = document.querySelectorAll('.custom-modal .custom-modal--close, .custom-modal .custom-modal--cta button, .custom-modal .custom-modal--background');

        if (modalCloseButton && modalCloseButton.length) {
            modalCloseButton.forEach(item => {
                item.addEventListener('click', e => {
                    const theCustomModal = document.querySelector('.custom-modal');
                    theCustomModal.remove();
                });
            });
        }
    }
}

async function fetchVehicle(kenteken) {
  const plate = (kenteken || "").toString().replace(/[^a-zA-Z0-9]/g, "").toUpperCase();
  if (!plate || plate.length < 5 || plate.length > 8) return null;

  const proxyUrl = "https://handleiding.caroptions.nl/api/voertuig.php";

  // 1) Primary: your server proxy (keeps key private)
  try {
    const r1 = await fetch(`${proxyUrl}?kenteken=${encodeURIComponent(plate)}`, {
      method: "GET",
      headers: { Accept: "application/json" },
      cache: "no-store"
    });

    // Handle rate limit from proxy
    if (r1.status === 429) {
      let msg = "Too many requests. Please try again in a moment.";
      let retry = null;

      try {
        const j = await r1.json();
        if (j?.message) msg = j.message;
        if (typeof j?.retry_after_seconds === "number") retry = j.retry_after_seconds;
      } catch (_) {}

      if (retry) msg += `\n\nRetry after ${retry} seconds.`;
      alert(msg);
      return null;
    }

    if (r1.ok) {
      const j1 = await r1.json().catch(() => null);
      const d1 = j1?.data ?? null;
      if (d1 && (d1.merk || d1.handelsbenaming || d1.datum_eerste_toelating)) return d1;
    }
  } catch (_) {
    // fall through to RDW
  }

  // 2) Fallback: RDW OpenData (no key)
  try {
    const r2 = await fetch(
      `https://opendata.rdw.nl/resource/m9d7-ebf2.json?kenteken=${encodeURIComponent(plate)}&$limit=1`,
      { method: "GET", headers: { Accept: "application/json" }, cache: "no-store" }
    );

    if (!r2.ok) return null;

    const arr = await r2.json().catch(() => null);
    if (!Array.isArray(arr) || arr.length === 0) return null;

    const d2 = arr[0] || {};
    const normalized = {
      merk: d2.merk || "",
      handelsbenaming: d2.handelsbenaming || "",
      datum_eerste_toelating: d2.datum_eerste_toelating || "",
      ...d2
    };

    if (normalized.merk || normalized.handelsbenaming || normalized.datum_eerste_toelating) return normalized;
  } catch (_) {}

  return null;
}

async function startKentekenFetcher(_field, _button, _addEvent) {
    let obj;

    const res = await fetch('//caroptions.com/cdn/shop/t/5/assets/kenteken_data.json?v=19963088588737928061774484625')
    // const res = await fetch('kenteken_data.json');

    obj = await res.json();

    if (_field) {
        const runner = async () => {
            const theCustomModal = document.querySelector('.custom-modal');
            if (theCustomModal) theCustomModal.remove();

            let kenteken = _field.value.replace(/[^a-zA-Z0-9]/g, '').toUpperCase();

            const data = await fetchVehicle(kenteken);

            if (!data) {
                activatePopUp(htmlFail);
                htmlFailFunctions('', kenteken);
                return;
            }

            matcher(data, obj, kenteken);
        };

        if (_button) {
            _button.addEventListener('click', event => {
                runner();
            });
        } else {
            runner();
        }

        if (_addEvent) {
            _field.addEventListener("keydown", event => {
                if (event.key === "Enter") {
                    runner();
                }
            });
        }
    }
}

function matcher(_data, _obj, _kenteken) {
    var theMatch = {
        kenteken: _kenteken
    };
    var varMatcherLicensePlate = ''; // This var is used to check if te session storage license plate is compatible with the giving varations of the car.

    const parseYear = date => {
        var strippedString = date.replace(/-/g, '');
        return parseInt(strippedString);
    }

    const includesType = (data, item) => {
        if (!data || !item) return false;

        if (typeof item === 'object') {
            for (let i = 0; i < item.length; i++) {
                if (data.toLowerCase().includes(item[i].toLowerCase())) {
                    return true;
                }
            }
            return false;
        } else {
            return data.toLowerCase().includes(item.toLowerCase());
        }
    }

    const startWithType = (data, item) => {
        if (!data || !item) return false;

        const dataLower = data.toLowerCase();

        if (typeof item === 'object') {
            for (let i = 0; i < item.length; i++) {
                if (dataLower.startsWith(item[i].toLowerCase())) {
                    return true;
                }
            }
            return false;
        } else {
            return dataLower.startsWith(item.toLowerCase());
        }
    }

    // Unsupported brands //

    function isUnsupported(merk, bouwjaar) {
        merk = merk?.toLowerCase();
        if (unsupportedRules.excludeBrands.includes(merk)) return true;

        const limitYear = unsupportedRules.excludeByYear[merk];
        if (limitYear && bouwjaar && parseInt(bouwjaar) <= limitYear) return true;

        return false;
    }

    const bouwjaarRaw = _data.datum_eerste_toelating || _data.bouwjaar || '';
    const bouwjaarClean = bouwjaarRaw.split('-')[0];

    if (!theMatch.boxBrand && isUnsupported(_data.merk, bouwjaarClean)) {
        const html = generateUnsupportedHTML(_data.merk, bouwjaarClean);
        activatePopUp(html);
        return;
    }

    // End Unsupported brands //

    if (_data.merk === 'PORSCHE' || _data.merk === 'porsche') {
        const porscheOptions = _obj.matches?.find(item => item.slug === 'porsche');
        if (!porscheOptions) {
            activatePopUp(htmlFail);
            htmlFailFunctions(_data, _kenteken);
        }

        let findVar = porscheOptions.variations?.find(item => {
            return _data.handelsbenaming && includesType(_data.handelsbenaming, item.type);
        });

        varMatcherLicensePlate = findVar;

        if (findVar && Array.isArray(findVar.var)) {
            const carYear = parseYear(_data.datum_eerste_toelating);

            // Zoek naar de juiste variant op basis van de datums in de JSON-structuur
            const matchedVar = findVar.var.find(variant => {
                const startDate = parseInt(variant.varStartDate);
                const endDate = parseInt(variant.varEndDate);
                return carYear >= startDate && carYear <= endDate;
            });

            if (matchedVar) {
                theMatch = {
                    kenteken: _kenteken,
                    boxBrand: 'porsche',
                    var: matchedVar.id
                };
            } else {
                // Als er geen overeenkomende variant is gevonden
                activatePopUp(htmlFail);
                htmlFailFunctions(_data, _kenteken);
            }
        } else {
            activatePopUp(htmlFail);
            htmlFailFunctions(_data, _kenteken);
        }
    }

    if (_data.merk === 'MINI' || _data.merk === 'mini') {
        const miniOptions = _obj.matches?.find(item => item.slug === 'mini');
        if (!miniOptions) {
            activatePopUp(htmlFail);
            htmlFailFunctions(_data, _kenteken);
        }

        const handelsbenaming = (_data.handelsbenaming || '').toLowerCase().trim();
        const inrichting = (_data.inrichting || '').toLowerCase().trim();

        let findVar = miniOptions.variations?.find(item => {
            // MINI One + stationwagen => zoek als Countryman
            if (handelsbenaming.startsWith('one') && inrichting === 'stationwagen') {
                return item.type === 'Countryman';
            }

            // Bestaande Paceman uitzondering
            if (handelsbenaming.includes('cooper') && inrichting === 'coupe') {
                return item.type === 'Paceman';
            }

            // Normale fallback op handelsbenaming
            if (handelsbenaming) {
                return includesType(_data.handelsbenaming, item.type);
            }

            return false;
        });

        findVar = findVar || miniOptions.variations?.find(item => item.type === 'Cooper');

        varMatcherLicensePlate = findVar;

        if (findVar && Array.isArray(findVar.var)) {
            const carYear = parseYear(_data.datum_eerste_toelating);

            // Zoek naar de juiste variant op basis van de datums in de JSON-structuur
            const matchedVar = findVar.var.find(variant => {
                const startDate = parseInt(variant.varStartDate);
                const endDate = parseInt(variant.varEndDate);
                return carYear >= startDate && carYear <= endDate;
            });

            if (matchedVar) {
                theMatch = {
                    kenteken: _kenteken,
                    boxBrand: 'mini',
                    var: matchedVar.id
                };
            } else {
                activatePopUp(htmlFail);
                htmlFailFunctions(_data, _kenteken);
            }
        } else {
            activatePopUp(htmlFail);
            htmlFailFunctions(_data, _kenteken);
        }
    }

    if (_data.merk === 'VOLVO' || _data.merk === 'volvo') {
        const volvoOptions = _obj.matches?.find(item => item.slug === 'volvo');
        if (!volvoOptions) {
            activatePopUp(htmlFail);
            htmlFailFunctions(_data, _kenteken);
        }

        let findVar = volvoOptions.variations?.find(item => _data.handelsbenaming && includesType(_data.handelsbenaming, item.type));

        varMatcherLicensePlate = findVar;

        if (findVar) {
            if (
                findVar.startDate &&
                parseYear(_data.datum_eerste_toelating) >= parseInt(findVar.startDate) &&
                !(findVar.endDate && !(parseYear(_data.datum_eerste_toelating) <= parseInt(findVar.endDate)))
            ) {
                theMatch = {
                    kenteken: _kenteken,
                    boxBrand: 'volvo',
                    var: findVar.var
                }
            }
        } else {
            activatePopUp(htmlFail);
            htmlFailFunctions(_data, _kenteken);
        }
    }

    if (includesType(_data.merk, 'VOLKSWAGEN') || includesType(_data.merk, 'volkswagen')) {
        const volkswagenOptions = _obj.matches?.find(item => item.slug === 'volkswagen');

        if (!volkswagenOptions) {
            activatePopUp(htmlFail);
            htmlFailFunctions(_data, _kenteken);
            return;
        }

        let findVar = volkswagenOptions.variations?.find(item => {
            return _data.handelsbenaming && includesType(_data.handelsbenaming, item.type);
        });

        varMatcherLicensePlate = findVar;

        if (findVar && Array.isArray(findVar.var)) {
            const carYear = parseYear(_data.datum_eerste_toelating);

            const matchedVar = findVar.var.find(variant => {
                const startDate = parseInt(variant.varStartDate);
                const endDate = parseInt(variant.varEndDate);
                return carYear >= startDate && carYear <= endDate;
            });

            if (matchedVar) {
                theMatch = {
                    kenteken: _kenteken,
                    boxBrand: 'volkswagen',
                    var: matchedVar.id
                };
            } else {
                activatePopUp(htmlFail);
                htmlFailFunctions(_data, _kenteken);
            }
        } else {
            activatePopUp(htmlFail);
            htmlFailFunctions(_data, _kenteken);
        }
    }

    if (includesType(_data.merk, 'ASTON MARTIN') || includesType(_data.merk, 'astron martin')) {
        const astonOptions = _obj.matches?.find(item => item.slug === 'aston-martin');

        if (!astonOptions) {
            activatePopUp(htmlFail);
            htmlFailFunctions(_data, _kenteken);
            return;
        }

        let findVar = astonOptions.variations?.find(item => {
            return _data.handelsbenaming && includesType(_data.handelsbenaming, item.type);
        });

        varMatcherLicensePlate = findVar;

        if (findVar && Array.isArray(findVar.var)) {
            const carYear = parseYear(_data.datum_eerste_toelating);

            const matchedVar = findVar.var.find(variant => {
                const startDate = parseInt(variant.varStartDate);
                const endDate = parseInt(variant.varEndDate);
                return carYear >= startDate && carYear <= endDate;
            });

            if (matchedVar) {
                theMatch = {
                    kenteken: _kenteken,
                    boxBrand: 'aston-martin',
                    var: matchedVar.id
                };
            } else {
                activatePopUp(htmlFail);
                htmlFailFunctions(_data, _kenteken);
            }
        } else {
            activatePopUp(htmlFail);
            htmlFailFunctions(_data, _kenteken);
        }
    }

    if (includesType(_data.merk, 'FIAT') || includesType(_data.merk, 'fiat')) {
        const fiatOptions = _obj.matches?.find(item => item.slug === 'fiat');

        if (!fiatOptions) {
            activatePopUp(htmlFail);
            htmlFailFunctions(_data, _kenteken);
            return;
        }

        let findVar = fiatOptions.variations?.find(item => {
            return _data.handelsbenaming && includesType(_data.handelsbenaming, item.type);
        });

        varMatcherLicensePlate = findVar;

        if (findVar && Array.isArray(findVar.var)) {
            const carYear = parseYear(_data.datum_eerste_toelating);

            const matchedVar = findVar.var.find(variant => {
                const startDate = parseInt(variant.varStartDate);
                const endDate = parseInt(variant.varEndDate);
                return carYear >= startDate && carYear <= endDate;
            });

            if (matchedVar) {
                theMatch = {
                    kenteken: _kenteken,
                    boxBrand: 'fiat',
                    url: `/products/carplay-android-auto-voor-fiat?variant=${matchedVar.id}#kenteken=${_kenteken}`,
                    var: matchedVar.id
                };
            } else {
                activatePopUp(htmlFail);
                htmlFailFunctions(_data, _kenteken);
            }
        } else {
            activatePopUp(htmlFail);
            htmlFailFunctions(_data, _kenteken);
        }
    }

    if (includesType(_data.merk, 'LAND ROVER') || includesType(_data.merk, 'land rover')) {
        const roverOptions = _obj.matches?.find(item => item.slug === 'land rover');
        if (!roverOptions) {
            activatePopUp(htmlFail);
            htmlFailFunctions(_data, _kenteken);
        }

        let findVar = roverOptions.variations?.find(item => _data.handelsbenaming && includesType(_data.handelsbenaming, item.type));

        varMatcherLicensePlate = findVar;

        if (findVar) {
            if (
                findVar.startDate &&
                parseYear(_data.datum_eerste_toelating) >= parseInt(findVar.startDate) &&
                !(findVar.endDate && !(parseYear(_data.datum_eerste_toelating) <= parseInt(findVar.endDate)))
            ) {
                theMatch = {
                    kenteken: _kenteken,
                    boxBrand: 'land-rover',
                    var: findVar.var
                }
            }
        } else {
            activatePopUp(htmlFail);
            htmlFailFunctions(_data, _kenteken);
        }
    }

    if (includesType(_data.merk, 'BENTLEY') || includesType(_data.merk, 'bentley')) {
        const bentleyOptions = _obj.matches?.find(item => item.slug === 'bentley');

        if (!bentleyOptions) {
            activatePopUp(htmlFail);
            htmlFailFunctions(_data, _kenteken);
            return;
        }

        let findVar = bentleyOptions.variations?.find(item => {
            return _data.handelsbenaming && includesType(_data.handelsbenaming, item.type);
        });

        varMatcherLicensePlate = findVar;

        if (findVar && Array.isArray(findVar.var)) {
            const carYear = parseYear(_data.datum_eerste_toelating);

            const matchedVar = findVar.var.find(variant => {
                const startDate = parseInt(variant.varStartDate);
                const endDate = parseInt(variant.varEndDate);
                return carYear >= startDate && carYear <= endDate;
            });

            if (matchedVar) {
                theMatch = {
                    kenteken: _kenteken,
                    boxBrand: 'bentley',
                    var: matchedVar.id
                };
            } else {
                activatePopUp(htmlFail);
                htmlFailFunctions(_data, _kenteken);
            }
        } else {
            activatePopUp(htmlFail);
            htmlFailFunctions(_data, _kenteken);
        }
    }

    if (includesType(_data.merk, 'ALFA') || includesType(_data.merk, 'alfa')) {

        const alfaOptions = _obj.matches?.find(item => item.slug === 'alfa romeo');
        if (!alfaOptions) {
            activatePopUp(htmlFail);
            htmlFailFunctions(_data, _kenteken);
        }

        let findVar = alfaOptions.variations?.find(item => _data.handelsbenaming && includesType(_data.handelsbenaming, item.type));

        varMatcherLicensePlate = findVar;

        if (findVar) {
            if (
                findVar.startDate &&
                parseYear(_data.datum_eerste_toelating) >= parseInt(findVar.startDate) &&
                !(findVar.endDate && !(parseYear(_data.datum_eerste_toelating) <= parseInt(findVar.endDate)))
            ) {
                theMatch = {
                    kenteken: _kenteken,
                    boxBrand: 'alfa-romeo',
                    var: findVar.var
                }
            }
        } else {
            activatePopUp(htmlFail);
            htmlFailFunctions(_data, _kenteken);
        }
    }

    if (_data.merk === 'CITROËN' || _data.merk === 'citroën' || _data.merk === 'CITROEN' || _data.merk === 'citroen') {
        const citroenOptions = _obj.matches?.find(item => item.slug === 'citroen');

        if (!citroenOptions) {
            activatePopUp(htmlFail);
            htmlFailFunctions(_data, _kenteken);
            return;
        }

        let findVar = citroenOptions.variations?.find(item => {
            return _data.handelsbenaming && includesType(_data.handelsbenaming, item.type);
        });

        varMatcherLicensePlate = findVar;

        if (findVar && Array.isArray(findVar.var)) {
            const carYear = parseYear(_data.datum_eerste_toelating);

            const matchedVar = findVar.var.find(variant => {
                const startDate = parseInt(variant.varStartDate);
                const endDate = parseInt(variant.varEndDate);
                return carYear >= startDate && carYear <= endDate;
            });

            if (matchedVar) {
                theMatch = {
                    kenteken: _kenteken,
                    boxBrand: 'citroen',
                    var: matchedVar.id
                };
            } else {
                activatePopUp(htmlFail);
                htmlFailFunctions(_data, _kenteken);
            }
        } else {
            activatePopUp(htmlFail);
            htmlFailFunctions(_data, _kenteken);
        }
    }

    if (_data.merk === 'DS' || _data.merk === 'ds') {
        const dsOptions = _obj.matches?.find(item => item.slug === 'ds');

        if (!dsOptions) {
            activatePopUp(htmlFail);
            htmlFailFunctions(_data, _kenteken);
            return;
        }

        let findVar = dsOptions.variations?.find(item => {
            return _data.handelsbenaming && includesType(_data.handelsbenaming, item.type);
        });

        varMatcherLicensePlate = findVar;

        if (findVar && Array.isArray(findVar.var)) {
            const carYear = parseYear(_data.datum_eerste_toelating);

            const matchedVar = findVar.var.find(variant => {
                const startDate = parseInt(variant.varStartDate);
                const endDate = parseInt(variant.varEndDate);
                return carYear >= startDate && carYear <= endDate;
            });

            if (matchedVar) {
                theMatch = {
                    kenteken: _kenteken,
                    boxBrand: 'ds',
                    url: `/products/carplaybox-citroen?variant=${matchedVar.id}#kenteken=${_kenteken}`,
                    var: matchedVar.id
                };
            } else {
                activatePopUp(htmlFail);
                htmlFailFunctions(_data, _kenteken);
            }
        } else {
            activatePopUp(htmlFail);
            htmlFailFunctions(_data, _kenteken);
        }
    }

    if (_data.merk === 'FERRARI' || _data.merk === 'ferrari') {
        const ferrariOptions = _obj.matches?.find(item => item.slug === 'ferrari');

        if (!ferrariOptions) {
            activatePopUp(htmlFail);
            htmlFailFunctions(_data, _kenteken);
            return;
        }

        let findVar = ferrariOptions.variations?.find(item => {
            return _data.handelsbenaming && includesType(_data.handelsbenaming, item.type);
        });

        varMatcherLicensePlate = findVar;

        if (findVar && Array.isArray(findVar.var)) {
            const carYear = parseYear(_data.datum_eerste_toelating);

            const matchedVar = findVar.var.find(variant => {
                const startDate = parseInt(variant.varStartDate);
                const endDate = parseInt(variant.varEndDate);
                return carYear >= startDate && carYear <= endDate;
            });

            if (matchedVar) {
                theMatch = {
                    kenteken: _kenteken,
                    boxBrand: 'ferrari',
                    var: matchedVar.id
                };
            } else {
                activatePopUp(htmlFail);
                htmlFailFunctions(_data, _kenteken);
            }
        } else {
            activatePopUp(htmlFail);
            htmlFailFunctions(_data, _kenteken);
        }
    }

    if (_data.merk === 'LAMBORGHINI' || _data.merk === 'lamborghini') {
        const lamborghiniOptions = _obj.matches?.find(item => item.slug === 'lamborghini');

        if (!lamborghiniOptions) {
            activatePopUp(htmlFail);
            htmlFailFunctions(_data, _kenteken);
            return;
        }

        let findVar = lamborghiniOptions.variations?.find(item => {
            return _data.handelsbenaming && includesType(_data.handelsbenaming, item.type);
        });

        varMatcherLicensePlate = findVar;

        if (findVar && Array.isArray(findVar.var)) {
            const carYear = parseYear(_data.datum_eerste_toelating);

            const matchedVar = findVar.var.find(variant => {
                const startDate = parseInt(variant.varStartDate);
                const endDate = parseInt(variant.varEndDate);
                return carYear >= startDate && carYear <= endDate;
            });

            if (matchedVar) {
                theMatch = {
                    kenteken: _kenteken,
                    boxBrand: 'lamborghini',
                    var: matchedVar.id
                };
            } else {
                activatePopUp(htmlFail);
                htmlFailFunctions(_data, _kenteken);
            }
        } else {
            activatePopUp(htmlFail);
            htmlFailFunctions(_data, _kenteken);
        }
    }

    if (_data.merk === 'SMART' || _data.merk === 'smart') {
        const smartOptions = _obj.matches?.find(item => item.slug === 'smart');

        if (!smartOptions) {
            activatePopUp(htmlFail);
            htmlFailFunctions(_data, _kenteken);
            return;
        }

        let findVar = smartOptions.variations?.find(item => {
            return _data.handelsbenaming && includesType(_data.handelsbenaming, item.type);
        });

        varMatcherLicensePlate = findVar;

        if (findVar && Array.isArray(findVar.var)) {
            const carYear = parseYear(_data.datum_eerste_toelating);

            const matchedVar = findVar.var.find(variant => {
                const startDate = parseInt(variant.varStartDate);
                const endDate = parseInt(variant.varEndDate);
                return carYear >= startDate && carYear <= endDate;
            });

            if (matchedVar) {
                theMatch = {
                    kenteken: _kenteken,
                    boxBrand: 'smart',
                    var: matchedVar.id
                };
            } else {
                activatePopUp(htmlFail);
                htmlFailFunctions(_data, _kenteken);
            }
        } else {
            activatePopUp(htmlFail);
            htmlFailFunctions(_data, _kenteken);
        }
    }

    if (_data.merk === 'MASERATI' || _data.merk === 'maserati') {
        const maseratiOptions = _obj.matches?.find(item => item.slug === 'maserati');

        if (!maseratiOptions) {
            activatePopUp(htmlFail);
            htmlFailFunctions(_data, _kenteken);
            return;
        }

        let findVar = maseratiOptions.variations?.find(item => {
            return _data.handelsbenaming && includesType(_data.handelsbenaming, item.type);
        });

        varMatcherLicensePlate = findVar;

        if (findVar && Array.isArray(findVar.var)) {
            const carYear = parseYear(_data.datum_eerste_toelating);

            const matchedVar = findVar.var.find(variant => {
                const startDate = parseInt(variant.varStartDate);
                const endDate = parseInt(variant.varEndDate);
                return carYear >= startDate && carYear <= endDate;
            });

            if (matchedVar) {
                theMatch = {
                    kenteken: _kenteken,
                    boxBrand: 'maserati',
                    var: matchedVar.id
                };
            } else {
                activatePopUp(htmlFail);
                htmlFailFunctions(_data, _kenteken);
            }
        } else {
            activatePopUp(htmlFail);
            htmlFailFunctions(_data, _kenteken);
        }
    }

    if (_data.merk === 'MC LAREN' || _data.merk === 'mc laren') {
        const mclarenOptions = _obj.matches?.find(item => item.slug === 'mclaren');

        if (!mclarenOptions) {
            activatePopUp(htmlFail);
            htmlFailFunctions(_data, _kenteken);
            return;
        }

        let findVar = mclarenOptions.variations?.find(item => {
            return _data.handelsbenaming && includesType(_data.handelsbenaming, item.type);
        });

        varMatcherLicensePlate = findVar;

        if (findVar && Array.isArray(findVar.var)) {
            const carYear = parseYear(_data.datum_eerste_toelating);

            const matchedVar = findVar.var.find(variant => {
                const startDate = parseInt(variant.varStartDate);
                const endDate = parseInt(variant.varEndDate);
                return carYear >= startDate && carYear <= endDate;
            });

            if (matchedVar) {
                theMatch = {
                    kenteken: _kenteken,
                    boxBrand: 'mc laren',
                    var: matchedVar.id
                };
            } else {
                activatePopUp(htmlFail);
                htmlFailFunctions(_data, _kenteken);
            }
        } else {
            activatePopUp(htmlFail);
            htmlFailFunctions(_data, _kenteken);
        }
    }

    if (_data.merk === 'NISSAN' || _data.merk === 'nissan') {
        const nissanOptions = _obj.matches?.find(item => item.slug === 'nissan');

        if (!nissanOptions) {
            activatePopUp(htmlFail);
            htmlFailFunctions(_data, _kenteken);
            return;
        }

        let findVar = nissanOptions.variations?.find(item => {
            return _data.handelsbenaming && includesType(_data.handelsbenaming, item.type);
        });

        varMatcherLicensePlate = findVar;

        if (findVar && Array.isArray(findVar.var)) {
            const carYear = parseYear(_data.datum_eerste_toelating);

            const matchedVar = findVar.var.find(variant => {
                const startDate = parseInt(variant.varStartDate);
                const endDate = parseInt(variant.varEndDate);
                return carYear >= startDate && carYear <= endDate;
            });

            if (matchedVar) {
                theMatch = {
                    kenteken: _kenteken,
                    boxBrand: 'nissan',
                    var: matchedVar.id
                };
            } else {
                activatePopUp(htmlFail);
                htmlFailFunctions(_data, _kenteken);
            }
        } else {
            activatePopUp(htmlFail);
            htmlFailFunctions(_data, _kenteken);
        }
    }

    if (_data.merk === 'SEAT' || _data.merk === 'seat') {
        const seatOptions = _obj.matches?.find(item => item.slug === 'seat');
        if (!seatOptions) {
            activatePopUp(htmlFail);
            htmlFailFunctions(_data, _kenteken);
        }

        let findVar = seatOptions.variations?.find(item => _data.handelsbenaming && includesType(_data.handelsbenaming, item.type));

        varMatcherLicensePlate = findVar;

        if (findVar) {
            if (
                findVar.startDate &&
                parseYear(_data.datum_eerste_toelating) >= parseInt(findVar.startDate) &&
                !(findVar.endDate && !(parseYear(_data.datum_eerste_toelating) <= parseInt(findVar.endDate)))
            ) {
                theMatch = {
                    kenteken: _kenteken,
                    boxBrand: 'seat',
                    var: findVar.var
                }
            }
        } else {
            activatePopUp(htmlFail);
            htmlFailFunctions(_data, _kenteken);
        }
    }

    if (_data.merk === 'SKODA' || _data.merk === 'skoda') {
        const skodaOptions = _obj.matches?.find(item => item.slug === 'skoda');
        if (!skodaOptions) {
            activatePopUp(htmlFail);
            htmlFailFunctions(_data, _kenteken);
        }

        let findVar = skodaOptions.variations?.find(item => _data.handelsbenaming && includesType(_data.handelsbenaming, item.type));

        varMatcherLicensePlate = findVar;

        if (findVar) {
            if (
                findVar.startDate &&
                parseYear(_data.datum_eerste_toelating) >= parseInt(findVar.startDate) &&
                !(findVar.endDate && !(parseYear(_data.datum_eerste_toelating) <= parseInt(findVar.endDate)))
            ) {
                theMatch = {
                    kenteken: _kenteken,
                    boxBrand: 'skoda',
                    var: findVar.var
                }
            }
        } else {
            activatePopUp(htmlFail);
            htmlFailFunctions(_data, _kenteken);
        }
    }

    if (includesType(_data.merk, 'MERCEDES') || includesType(_data.merk, 'mercedes')) {
        const mercedesOptions = _obj.matches?.find(item => item.slug === 'mercedes');
        if (!mercedesOptions) {
            activatePopUp(htmlFail);
            htmlFailFunctions(_data, _kenteken);
        }

        function checkType(dynamicValue, type) {
            const regex = new RegExp(`^(AMG\\s+${type}|${type})(?![a-zA-Z])`, 'i');
            return regex.test(dynamicValue);
        }

        let findVar = mercedesOptions.variations?.find(item =>
            _data.handelsbenaming && checkType(_data.handelsbenaming, item.type)
        );

        varMatcherLicensePlate = findVar;

        if (findVar && Array.isArray(findVar.var)) {
            const carYear = parseYear(_data.datum_eerste_toelating);

            const matchedVar = findVar.var.find(variant => {
                const startDate = parseInt(variant.varStartDate);
                const endDate = parseInt(variant.varEndDate);
                return carYear >= startDate && carYear <= endDate;
            });

            if (matchedVar) {
                if (matchedVar.id) {
                    theMatch = {
                        kenteken: _kenteken,
                        boxBrand: 'mercedes',
                        var: matchedVar.id
                    };
                } else if (matchedVar.url) {
                    theMatch = {
                        kenteken: _kenteken,
                        boxBrand: 'mercedes',
                        url: matchedVar.url
                    };
                } else {
                    activatePopUp(htmlFail);
                    htmlFailFunctions(_data, _kenteken);
                }
            } else {
                activatePopUp(htmlFail);
                htmlFailFunctions(_data, _kenteken);
            }
        } else {
            activatePopUp(htmlFail);
            htmlFailFunctions(_data, _kenteken);
        }
    }

    if (includesType(_data.merk, 'JEEP') || includesType(_data.merk, 'jeep')) {
        const jeepOptions = _obj.matches?.find(item => item.slug === 'jeep');

        if (!jeepOptions) {
            activatePopUp(htmlFail);
            htmlFailFunctions(_data, _kenteken);
            return;
        }

        let findVar = jeepOptions.variations?.find(item => {
            return _data.handelsbenaming && includesType(_data.handelsbenaming, item.type);
        });

        varMatcherLicensePlate = findVar;

        if (findVar && Array.isArray(findVar.var)) {
            const carYear = parseYear(_data.datum_eerste_toelating);

            const matchedVar = findVar.var.find(variant => {
                const startDate = parseInt(variant.varStartDate);
                const endDate = parseInt(variant.varEndDate);
                return carYear >= startDate && carYear <= endDate;
            });

            if (matchedVar) {
                theMatch = {
                    kenteken: _kenteken,
                    boxBrand: 'jeep',
                    var: matchedVar.id
                };
            } else {
                activatePopUp(htmlFail);
                htmlFailFunctions(_data, _kenteken);
            }
        } else {
            activatePopUp(htmlFail);
            htmlFailFunctions(_data, _kenteken);
        }
    }


    if (includesType(_data.merk, 'Lexus') || includesType(_data.merk, 'lexus')) {
        const lexusOptions = _obj.matches?.find(item => item.slug === 'lexus');
        if (!lexusOptions) {
            activatePopUp(htmlFail);
            htmlFailFunctions(_data, _kenteken);
        }

        let findVar = lexusOptions.variations?.find(item => _data.handelsbenaming && includesType(_data.handelsbenaming, item.type));

        varMatcherLicensePlate = findVar;

        if (findVar) {
            if (
                findVar.startDate &&
                parseYear(_data.datum_eerste_toelating) >= parseInt(findVar.startDate) &&
                !(findVar.endDate && !(parseYear(_data.datum_eerste_toelating) <= parseInt(findVar.endDate)))
            ) {
                if (findVar.updateDate) {
                    if (parseYear(_data.datum_eerste_toelating) <= parseInt(findVar.updateDate)) {
                        theMatch = {
                            kenteken: _kenteken,
                            boxBrand: 'lexus',
                            var: findVar.var[0]
                        }
                    } else if (parseYear(_data.datum_eerste_toelating) > parseInt(findVar.updateDate)) {
                        theMatch = {
                            kenteken: _kenteken,
                            boxBrand: 'lexus',
                            var: findVar.var[1]
                        }
                    }
                } else {
                    theMatch = {
                        kenteken: _kenteken,
                        boxBrand: 'lexus',
                        var: findVar.var
                    }
                }
            }
        } else {
            activatePopUp(htmlFail);
            htmlFailFunctions(_data, _kenteken);
        }
    }

    if (includesType(_data.merk, 'AUDI') || includesType(_data.merk, 'audi')) {
        const audiOptions = _obj.matches?.find(item => item.slug === 'audi');

        if (!audiOptions) {
            activatePopUp(htmlFail);
            htmlFailFunctions(_data, _kenteken);
            return;
        }

        let findVar = audiOptions.variations?.find(item => {
            return _data.handelsbenaming && includesType(_data.handelsbenaming, item.type);
        });

        varMatcherLicensePlate = findVar;

        if (findVar && Array.isArray(findVar.var)) {
            const carYear = parseYear(_data.datum_eerste_toelating);

            const matchedVar = findVar.var.find(variant => {
                const startDate = parseInt(variant.varStartDate);
                const endDate = parseInt(variant.varEndDate);
                return carYear >= startDate && carYear <= endDate;
            });

            if (matchedVar) {
                theMatch = {
                    kenteken: _kenteken,
                    boxBrand: 'audi',
                    var: matchedVar.id
                };
            } else {
                activatePopUp(htmlFail);
                htmlFailFunctions(_data, _kenteken);
            }
        } else {
            activatePopUp(htmlFail);
            htmlFailFunctions(_data, _kenteken);
        }
    }

    if (includesType(_data.merk, 'TOYOTA') || includesType(_data.merk, 'toyota')) {

        const toyotaOptions = _obj.matches?.find(item => item.slug === 'toyota');

        if (!toyotaOptions) {
            activatePopUp(htmlFail);
            htmlFailFunctions(_data, _kenteken);
        }

        let findVar = toyotaOptions.variations?.find(item => _data.handelsbenaming && includesType(_data.handelsbenaming, item.type));

        varMatcherLicensePlate = findVar;

        if (findVar) {
            if (
                findVar.startDate &&
                parseYear(_data.datum_eerste_toelating) >= parseInt(findVar.startDate) &&
                !(findVar.endDate && !(parseYear(_data.datum_eerste_toelating) <= parseInt(findVar.endDate)))
            ) {
                if (findVar.updateDate) {
                    if (parseYear(_data.datum_eerste_toelating) <= parseInt(findVar.updateDate)) {
                        theMatch = {
                            kenteken: _kenteken,
                            boxBrand: 'toyota',
                            var: findVar.var[0]
                        }
                    } else if (parseYear(_data.datum_eerste_toelating) > parseInt(findVar.updateDate)) {
                        theMatch = {
                            kenteken: _kenteken,
                            boxBrand: 'toyota',
                            var: findVar.var[1]
                        }
                    }
                } else {
                    theMatch = {
                        kenteken: _kenteken,
                        boxBrand: 'toyota',
                        var: findVar.var
                    }
                }
            }
        } else {
            activatePopUp(htmlFail);
            htmlFailFunctions(_data, _kenteken);
        }
    }

    if (includesType(_data.merk, 'FORD') || includesType(_data.merk, 'ford')) {

        const fordOptions = _obj.matches?.find(item => item.slug === 'ford');

        if (!fordOptions) {
            activatePopUp(htmlFail);
            htmlFailFunctions(_data, _kenteken);
        }

        let findVar = fordOptions.variations?.find(item => _data.handelsbenaming && includesType(_data.handelsbenaming, item.type));

        varMatcherLicensePlate = findVar;

        if (findVar) {
            if (
                findVar.startDate &&
                parseYear(_data.datum_eerste_toelating) >= parseInt(findVar.startDate) &&
                !(findVar.endDate && !(parseYear(_data.datum_eerste_toelating) <= parseInt(findVar.endDate)))
            ) {
                if (findVar.updateDate) {
                    if (parseYear(_data.datum_eerste_toelating) <= parseInt(findVar.updateDate)) {
                        theMatch = {
                            kenteken: _kenteken,
                            boxBrand: 'ford',
                            var: findVar.var[0]
                        }
                    } else if (parseYear(_data.datum_eerste_toelating) > parseInt(findVar.updateDate)) {
                        theMatch = {
                            kenteken: _kenteken,
                            boxBrand: 'ford',
                            var: findVar.var[1]
                        }
                    }
                } else {
                    theMatch = {
                        kenteken: _kenteken,
                        boxBrand: 'ford',
                        var: findVar.var
                    }
                }
            }
        } else {
            activatePopUp(htmlFail);
            htmlFailFunctions(_data, _kenteken);
        }
    }

    if (includesType(_data.merk, 'TESLA') || includesType(_data.merk, 'tesla')) {

        const teslaOptions = _obj.matches?.find(item => item.slug === 'tesla');

        if (!teslaOptions) {
            activatePopUp(htmlFail);
            htmlFailFunctions(_data, _kenteken);
        }

        let findVar = teslaOptions.variations?.find(item => _data.handelsbenaming && includesType(_data.handelsbenaming, item.type));

        varMatcherLicensePlate = findVar;

        if (findVar) {
            if (
                findVar.startDate &&
                parseYear(_data.datum_eerste_toelating) >= parseInt(findVar.startDate) &&
                !(findVar.endDate && !(parseYear(_data.datum_eerste_toelating) <= parseInt(findVar.endDate)))
            ) {
                if (findVar.updateDate) {
                    if (parseYear(_data.datum_eerste_toelating) <= parseInt(findVar.updateDate)) {
                        theMatch = {
                            kenteken: _kenteken,
                            boxBrand: 'tesla',
                            var: findVar.var[0]
                        }
                    } else if (parseYear(_data.datum_eerste_toelating) > parseInt(findVar.updateDate)) {
                        theMatch = {
                            kenteken: _kenteken,
                            boxBrand: 'tesla',
                            var: findVar.var[1]
                        }
                    }
                } else {
                    theMatch = {
                        kenteken: _kenteken,
                        boxBrand: 'tesla',
                        var: findVar.var
                    }
                }
            }
        } else {
            activatePopUp(htmlFail);
            htmlFailFunctions(_data, _kenteken);
        }
    }

    if (includesType(_data.merk, 'DODGE') || includesType(_data.merk, 'dodge')) {

        const dodgeOptions = _obj.matches?.find(item => item.slug === 'dodge');

        if (!dodgeOptions) {
            activatePopUp(htmlFail);
            htmlFailFunctions(_data, _kenteken);
        }

        let findVar = dodgeOptions.variations?.find(item => _data.handelsbenaming && includesType(_data.handelsbenaming, item.type));

        varMatcherLicensePlate = findVar;

        if (findVar) {
            if (
                findVar.startDate &&
                parseYear(_data.datum_eerste_toelating) >= parseInt(findVar.startDate) &&
                !(findVar.endDate && !(parseYear(_data.datum_eerste_toelating) <= parseInt(findVar.endDate)))
            ) {
                if (findVar.updateDate) {
                    if (parseYear(_data.datum_eerste_toelating) <= parseInt(findVar.updateDate)) {
                        theMatch = {
                            kenteken: _kenteken,
                            boxBrand: 'dodge',
                            var: findVar.var[0]
                        }
                    } else if (parseYear(_data.datum_eerste_toelating) > parseInt(findVar.updateDate)) {
                        theMatch = {
                            kenteken: _kenteken,
                            boxBrand: 'dodge',
                            var: findVar.var[1]
                        }
                    }
                } else {
                    theMatch = {
                        kenteken: _kenteken,
                        boxBrand: 'dodge',
                        var: findVar.var
                    }
                }
            }
        } else {
            activatePopUp(htmlFail);
            htmlFailFunctions(_data, _kenteken);
        }
    }

    if (includesType(_data.merk, 'PEUGEOT') || includesType(_data.merk, 'peugeot')) {

        const peugeotOptions = _obj.matches?.find(item => item.slug === 'peugeot');

        if (!peugeotOptions) {
            activatePopUp(htmlFail);
            htmlFailFunctions(_data, _kenteken);
        }

        let findVar = peugeotOptions.variations?.find(item => _data.handelsbenaming && includesType(_data.handelsbenaming, item.type));

        varMatcherLicensePlate = findVar;

        if (findVar) {
            if (
                findVar.startDate &&
                parseYear(_data.datum_eerste_toelating) >= parseInt(findVar.startDate) &&
                !(findVar.endDate && !(parseYear(_data.datum_eerste_toelating) <= parseInt(findVar.endDate)))
            ) {
                if (findVar.updateDate) {
                    if (parseYear(_data.datum_eerste_toelating) <= parseInt(findVar.updateDate)) {
                        theMatch = {
                            kenteken: _kenteken,
                            boxBrand: 'peugeot',
                            var: findVar.var[0]
                        }
                    } else if (parseYear(_data.datum_eerste_toelating) > parseInt(findVar.updateDate)) {
                        theMatch = {
                            kenteken: _kenteken,
                            boxBrand: 'peugeot',
                            var: findVar.var[1]
                        }
                    }
                } else {
                    theMatch = {
                        kenteken: _kenteken,
                        boxBrand: 'peugeot',
                        var: findVar.var
                    }
                }
            }
        } else {
            activatePopUp(htmlFail);
            htmlFailFunctions(_data, _kenteken);
        }
    }

    if (includesType(_data.merk, 'JAGUAR') || includesType(_data.merk, 'jaguar')) {

        const jaguarOptions = _obj.matches?.find(item => item.slug === 'jaguar');

        if (!jaguarOptions) {
            activatePopUp(htmlFail);
            htmlFailFunctions(_data, _kenteken);
        }

        let findVar = jaguarOptions.variations?.find(item => _data.handelsbenaming && includesType(_data.handelsbenaming, item.type));

        varMatcherLicensePlate = findVar;

        if (findVar) {
            if (
                findVar.startDate &&
                parseYear(_data.datum_eerste_toelating) >= parseInt(findVar.startDate) &&
                !(findVar.endDate && !(parseYear(_data.datum_eerste_toelating) <= parseInt(findVar.endDate)))
            ) {
                if (findVar.updateDate) {
                    if (parseYear(_data.datum_eerste_toelating) <= parseInt(findVar.updateDate)) {
                        theMatch = {
                            kenteken: _kenteken,
                            boxBrand: 'jaguar',
                            var: findVar.var[0]
                        }
                    } else if (parseYear(_data.datum_eerste_toelating) > parseInt(findVar.updateDate)) {
                        theMatch = {
                            kenteken: _kenteken,
                            boxBrand: 'jaguar',
                            var: findVar.var[1]
                        }
                    }
                } else {
                    theMatch = {
                        kenteken: _kenteken,
                        boxBrand: 'jaguar',
                        var: findVar.var
                    }
                }
            }
        } else {
            activatePopUp(htmlFail);
            htmlFailFunctions(_data, _kenteken);
        }
    }

    if (includesType(_data.merk, 'MAZDA') || includesType(_data.merk, 'mazda')) {
        const mazdaOptions = _obj.matches?.find(item => item.slug === 'mazda');

        if (!mazdaOptions) {
            activatePopUp(htmlFail);
            htmlFailFunctions(_data, _kenteken);
        }

        let findVar = mazdaOptions.variations?.find(item => _data.handelsbenaming && includesType(_data.handelsbenaming, item.type));

        varMatcherLicensePlate = findVar;

        if (findVar) {
            if (
                findVar.startDate &&
                parseYear(_data.datum_eerste_toelating) >= parseInt(findVar.startDate) &&
                !(findVar.endDate && !(parseYear(_data.datum_eerste_toelating) <= parseInt(findVar.endDate)))
            ) {
                if (findVar.updateDate) {
                    if (parseYear(_data.datum_eerste_toelating) <= parseInt(findVar.updateDate)) {
                        theMatch = {
                            kenteken: _kenteken,
                            boxBrand: 'mazda',
                            url: `/products/carplay-android-auto-voor-mazda?variant=${findVar.var[0]}#kenteken=${_kenteken}`,
                            var: findVar.var[0]
                        }
                    } else if (parseYear(_data.datum_eerste_toelating) > parseInt(findVar.updateDate)) {
                        theMatch = {
                            kenteken: _kenteken,
                            boxBrand: 'mazda',
                            url: `/products/carplay-android-auto-voor-mazda?variant=${findVar.var[1]}#kenteken=${_kenteken}`,
                            var: findVar.var[1]
                        }
                    }
                } else {
                    theMatch = {
                        kenteken: _kenteken,
                        boxBrand: 'mazda',
                        url: `/products/carplay-android-auto-voor-mazda?variant=${findVar.var}#kenteken=${_kenteken}`,
                        var: findVar.var
                    }
                }
            }
        } else {
            activatePopUp(htmlFail);
            htmlFailFunctions(_data, _kenteken);
        }
    }

    if (includesType(_data.merk, 'BMW') || includesType(_data.merk, 'bmw')) {
        const bmwOptions = _obj.matches?.find(item => item.slug === 'bmw');
        if (!bmwOptions) {
            activatePopUp(htmlFail);
            htmlFailFunctions(_data, _kenteken);
        }

        // 1) Kies match-bron: normaal handelsbenaming, maar bij "X REIHE" fallback naar TYPE
        const isXReihe =
            typeof _data.handelsbenaming === 'string' &&
            _data.handelsbenaming.trim().toUpperCase() === 'X REIHE';

        // Pas dit veld aan als het bij jou bv. _data.TYPE heet:
        const typeValue = (_data.type ?? _data.TYPE ?? '').toString();

        const matchSource = isXReihe ? typeValue : (_data.handelsbenaming ?? '');

        // 2) Probeer match te vinden op de gekozen bron
        let findVar = bmwOptions.variations?.find(
            item => matchSource && startWithType(matchSource, item.type)
        );

        // (optioneel) als je bij "X REIHE" eerst handelsbenaming probeerde en daarna pas TYPE wil:
        // laat me weten, dan pas ik de volgorde aan.

        varMatcherLicensePlate = findVar;

        if (findVar) {
            if (
                findVar.startDate &&
                parseYear(_data.datum_eerste_toelating) >= parseInt(findVar.startDate) &&
                !(findVar.endDate && !(parseYear(_data.datum_eerste_toelating) <= parseInt(findVar.endDate)))
            ) {
                if (findVar.updateDate) {
                    if (parseYear(_data.datum_eerste_toelating) <= parseInt(findVar.updateDate)) {
                        theMatch = {
                            kenteken: _kenteken,
                            boxBrand: 'bmw',
                            var: findVar.var[0]
                        }
                    } else if (parseYear(_data.datum_eerste_toelating) > parseInt(findVar.updateDate)) {
                        theMatch = {
                            kenteken: _kenteken,
                            boxBrand: 'bmw',
                            var: findVar.var[1]
                        }
                    }
                } else {
                    theMatch = {
                        kenteken: _kenteken,
                        boxBrand: 'bmw',
                        var: findVar.var
                    }
                }
            }
        } else {
            activatePopUp(htmlFail);
            htmlFailFunctions(_data, _kenteken);
        }
    }

    redirectToPage(theMatch, varMatcherLicensePlate, _data);
}

async function redirectToPage(_data, _varMatcherLicensePlate, licensePlateData) {
    const payload = {
        kenteken: _data.kenteken,
        status: _data.boxBrand && (_data.var || _data.url) ? 1 : 0, // Nu ook een URL als geldig status criterium
        merk: licensePlateData.merk || '',
        type: licensePlateData.handelsbenaming || '',
        bouwjaar: licensePlateData.datum_eerste_toelating || '',
    };

    try {
        const response = await fetch('https://auto-fotografie.nl/post/save_license.php', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(payload),
        });

        const result = await response.json();

        if (payload.status === 1) {
            // Altijd hele RDW-data bewaren voor de productpagina
            sessionStorage.setItem("licensePlateFullData", JSON.stringify(licensePlateData));

            // Normale flow voor ALLE kentekens
            handleSuccess(_data, _varMatcherLicensePlate);
        } else {
            handleFailure(payload);
        }
    } catch (error) {
        if (payload.status === 0) handleFailure(payload);
    }
}


function handleSuccess(_data, _varMatcherLicensePlate) {
    // Basis kenteken-info bewaren
    sessionStorage.setItem('licensePlate', JSON.stringify({
        license: _data.kenteken || null,
        brand: _data.boxBrand || null,
        var: _varMatcherLicensePlate?.var || _varMatcherLicensePlate || null
    }));

    // Altijd de nieuwe scan-modal laten gebruiken
    sessionStorage.setItem('kentekenPopUp', 'scan');

    // Redirect naar juiste productpagina
    if (_data.url) {
        window.location.href = _data.url;
    } else if (_data.var && _data.kenteken) {
        const urlBase = "https://www.caroptions.nl/products/";
        window.location.href = `${urlBase}carplaybox-${_data.boxBrand}?variant=${_data.var}#kenteken=${_data.kenteken}`;
    }

    plateOrderRule(document.querySelector('.plate_matcher_order_rule input'));
    hideLicencePlate();
}

function handleFailure(data) {
    const selectedBrand = document.getElementById('field1')?.value;
    if (!selectedBrand) {
        activatePopUp(htmlFail);
        htmlFailFunctions(data, data.kenteken);
    }
}

if (getKentekenFields && getKentekenFields.length) {
    getKentekenFields.forEach(item => {
        const field = item.querySelector('input');
        const button = item.querySelector('#checkbutton');

        if (field && button) {
            startKentekenFetcher(field, button, true);
        }
    });
}

// Kenteken matcher

function plateOrderRule(_input, _hiddenInput) {
    var licensePlateData = sessionStorage.getItem('licensePlate');
    licensePlateData = JSON.parse(licensePlateData);
    var varValue = findCoreSelector.value;

    if (varValue && _input && _hiddenInput && licensePlateData) {
        if (
            (typeof licensePlateData.var === 'string' && licensePlateData.var && licensePlateData.var.includes(varValue)) ||
            (Array.isArray(licensePlateData.var) && licensePlateData.var && licensePlateData.var.includes(varValue))
        ) {
            _input.parentNode.classList.add('has-success');
            _input.value = licensePlateData.license;
            _hiddenInput.value = licensePlateData.license;
            _hiddenInput.setAttribute('name', 'properties[Kenteken]');
        } else {
            _input.parentNode.classList.remove('has-success');
            _input.value = '';
            _hiddenInput.value = '';
            _hiddenInput.removeAttribute('name');
        }
    }
}

function hideLicencePlate() {
    var licensePlateData = sessionStorage.getItem('licensePlate');
    licensePlateData = JSON.parse(licensePlateData);
    if (!licensePlateData || typeof licensePlateData !== 'object') return;
    if (licensePlateData.license) {
        var getPlateWrapper = document.querySelector('.license_plate_wrapper');
        var getPlatePicker = document.querySelector('.license_plate_wrapper__picker');
        if (!getPlatePicker) return;
        getPlatePicker.classList.add('hide');

        var html = `<header>Kenteken: <strong>${licensePlateData.license}</strong></header><span id="select_new_plate" class="close_plate">Nieuw kenteken selecteren</span><div class="close_plate"></div>`
        var newWrapper = document.createElement("div");
        newWrapper.classList.add('license_plate_wrapper__selection');
        newWrapper.innerHTML = html;
        getPlateWrapper.append(newWrapper);

        var closeButton = document.querySelectorAll('.close_plate');
        if (!closeButton || !closeButton.length) return;
        closeButton.forEach(item => {
            item.addEventListener('click', () => {
                newWrapper.remove();
                getPlatePicker.classList.remove('hide');
                sessionStorage.removeItem('licensePlate');
            });
        });
    }
}

if (findCoreSelector) {
    findCoreSelector.addEventListener('change', function () {
        var findInputLicense = document.querySelector('.plate_matcher_order_rule input');
        var findHiddenInputLicense = document.querySelector('.gpo-hidden-inputs [data-field-name="Kenteken"]');
        plateOrderRule(findInputLicense, findHiddenInputLicense);
    });

    document.addEventListener('DOMContentLoaded', function () {
        setTimeout(function () {
            var findInputLicense = document.querySelector('.plate_matcher_order_rule input');
            var findHiddenInputLicense = document.querySelector('.gpo-hidden-inputs [data-field-name="Kenteken"]');
            plateOrderRule(findInputLicense, findHiddenInputLicense);
        }, 100);

        var licensePlatePopUp = sessionStorage.getItem('kentekenPopUp');

        if (licensePlatePopUp) {
            sessionStorage.removeItem('kentekenPopUp');

            const lp = sessionStorage.getItem('licensePlate');
            let lpData = {};
            try { lpData = JSON.parse(lp); } catch(e) {}

            if (licensePlatePopUp === 'scan') {
                // Nieuwe scan animatie popup
                showScanSuccessModal(lpData, lpData?.license || '');
            } else {
                // Oude standaard popup
                activatePopUp(htmlComplete);
            }
        }

        hideLicencePlate();
    });
}













function forceThemeVisible() {
    console.log('run visible');
    const html = document.documentElement;

    // t4sp-theme gebruikt vaak deze classes om fade-in te blokkeren:
    // .smt-loadding, .smt-loading, .t4sp-theme
    if (html.classList.contains('smt-loadding') || html.classList.contains('smt-loading')) {

        // Haal blocking classes weg
        html.classList.remove('smt-loadding', 'smt-loading');

        // Zet een inline style die altijd werkt
        html.style.opacity = "1 !important";
        html.style.visibility = "visible !important";

        // Extra fallback:
        setTimeout(() => {
            html.style.removeProperty('opacity');
            html.style.removeProperty('visibility');
        }, 500);
    }
}

function waitUntilVisible(el, callback, maxWait = 1500) {
    if (!el) return;

    let done = false;
    const start = performance.now();

    function finish() {
        if (done) return;
        done = true;

        // mini delay zodat de browser tijd heeft om te painten / CSS toe te passen
        setTimeout(() => {
            callback();
        }, 120); // 100–150ms voelt meestal lekker
    }

    // Moderne manier: IntersectionObserver (wacht tot element écht in viewport is)
    if ('IntersectionObserver' in window) {
        const observer = new IntersectionObserver((entries) => {
            const entry = entries[0];
            const now = performance.now();

            if (entry.isIntersecting) {
                observer.disconnect();
                finish();
            } else if (now - start > maxWait) {
                // Fail-safe: na X ms toch gewoon starten
                observer.disconnect();
                finish();
            }
        }, {
            threshold: 0.2 // 20% in beeld
        });

        observer.observe(el);

        // Extra fail-safe voor het geval de observer nooit fired
        setTimeout(() => {
            if (!done) {
                observer.disconnect();
                finish();
            }
        }, maxWait + 100);

    } else {
        // Fallback: oude raf-check (voor ancient browsers)
        function check() {
            if (!document.body.contains(el)) return;

            const rect = el.getBoundingClientRect();
            const visible =
                rect.width > 0 &&
                rect.height > 0 &&
                rect.bottom >= 0 &&
                rect.top <= (window.innerHeight || document.documentElement.clientHeight);

            const now = performance.now();

            if (visible || (now - start > maxWait)) {
                finish();
                return;
            }

            requestAnimationFrame(check);
        }

        requestAnimationFrame(check);
    }
}

function showScanSuccessModal(licensePlateData, kenteken) {
    forceThemeVisible();

    /* ============================
       READ STORED VEHICLE DATA
       ============================ */
    const stored = sessionStorage.getItem("licensePlateFullData");
    let fullData = {};
    try { fullData = JSON.parse(stored) || {}; } catch(e){}

    /* ============================
       MERK, TYPE, BOUWJAAR
       ============================ */
    const merkRaw = (licensePlateData?.merk || fullData?.merk || "").trim();
    const merk = merkRaw.toLowerCase();

    const type =
        licensePlateData?.handelsbenaming ||
        fullData?.handelsbenaming ||
        licensePlateData?.type ||
        fullData?.type ||
        "";

    const rawDate =
        licensePlateData?.datum_eerste_toelating ||
        fullData?.datum_eerste_toelating ||
        licensePlateData?.bouwjaar ||
        fullData?.bouwjaar ||
        "";

    const bouwjaar = rawDate ? rawDate.split("-")[0] : "";

    const voertuigTitel = [merkRaw, type, bouwjaar].filter(Boolean).join(" ");

    /* ============================
       IMAGE MAP
       ============================ */
    const brandImageMap = {
        audi: "https://cdn.shopify.com/s/files/1/0727/7477/9171/files/audi_scan_671289ed-0d37-48b0-8365-cc217f8e93ae.jpg?v=1764074018",
        bmw: "https://cdn.shopify.com/s/files/1/0727/7477/9171/files/bmw_scan_45e0e6fa-269b-4e82-ac19-1905f3732bbd.jpg?v=1764074018",
        mercedes: "https://cdn.shopify.com/s/files/1/0727/7477/9171/files/mercedes_scan.jpg?v=1764074018",
        volkswagen: "https://cdn.shopify.com/s/files/1/0727/7477/9171/files/golf_scan.jpg?v=1764074018",
        volvo: "https://cdn.shopify.com/s/files/1/0727/7477/9171/files/volvo_scan.jpg?v=1764074018",
        porsche: "https://cdn.shopify.com/s/files/1/0727/7477/9171/files/porsche_scan.jpg?v=1764074018",
        lexus: "https://cdn.shopify.com/s/files/1/0727/7477/9171/files/lexus_scan.jpg?v=1764074018",
        mini: "https://cdn.shopify.com/s/files/1/0727/7477/9171/files/mini_scan.jpg?v=1764074018",
        ford: "https://cdn.shopify.com/s/files/1/0727/7477/9171/files/ford_scan.jpg?v=1764074018",
        mazda: "https://cdn.shopify.com/s/files/1/0727/7477/9171/files/mazda_scan.jpg?v=1764110434",
        peugeot: "https://cdn.shopify.com/s/files/1/0727/7477/9171/files/peugeot_scan.jpg?v=1764110434",
        dodge: "https://cdn.shopify.com/s/files/1/0727/7477/9171/files/dodge_scan.jpg?v=1764110434",
        toyota: "https://cdn.shopify.com/s/files/1/0727/7477/9171/files/toyota_scan.jpg?v=1764110434",
        citroen: "https://cdn.shopify.com/s/files/1/0727/7477/9171/files/citroen_scan.jpg?v=1764110434",
        'land rover': "https://cdn.shopify.com/s/files/1/0727/7477/9171/files/range_scan.jpg?v=1764110434",
        'alfa romeo': "https://cdn.shopify.com/s/files/1/0727/7477/9171/files/alfa_scan.jpg?v=1764110434"
    };

    const fallbackImage =
        "https://cdn.shopify.com/s/files/1/0727/7477/9171/files/random_scan.jpg?v=1764074288";

    const chosenImage = brandImageMap[merk] || fallbackImage;

    /* ============================
       BUILD MODAL HTML
       ============================ */
    const scanHtml = `
    <div class="custom-modal--background co-scan-modal__background"></div>
    <div class="custom-modal--wrapper co-scan-modal__wrapper">
        <div class="custom-modal--inner co-scan-modal__inner">

            <div class="co-scan-modal__header">

                <div class="co-scan-modal__image">
                    <div class="co-scan-modal__image-inner">

                        <img class="co-scan-modal__image-icon" src="${chosenImage}" alt="scan" />

                        <div class="co-scan-modal__image-scan--wrapper">
                            <div class="co-scan-modal__image-scan"></div>
                        </div>

                        <!-- FANCY CHECK -->
                        <div class="co-scan-check-overlay">
                            <label class="co-scan-check-field">
                                <input class="co-scan-check-field__checkbox" type="checkbox">
                                <span class="co-scan-check-field__label">
                                    ${window.__SCAN_CHECK_SVG__}
                                    <span class="co-scan-check-field__sr-only">Check</span>
                                </span>
                            </label>
                        </div>

                    </div>
                </div>

                <h2 class="co-scan-modal__title" data-co-scan-title>Voertuig scannen...</h2>
                <h3 class="co-scan-modal__vehicle" data-co-scan-vehicle>
                    ${voertuigTitel || "Voertuig gegevens worden opgehaald"}
                </h3>
                <p class="co-scan-modal__subtitle" data-co-scan-subtitle>Bezig met scannen</p>
            </div>

            <div class="co-scan-modal__progress">

                ${createProgressRow("kenteken", "Kenteken data")}
                ${createProgressRow("bouwjaar", "Bouwjaar check")}
                ${createProgressRow("scherm", "SCHERM EN RADIO CHECK")}
                ${createProgressRow("canbus", "Canbus Check")}

            </div>

            <div class="custom-modal--cta co-scan-modal__footer">
                <button type="button" class="co-scan-modal__button">Product bekijken</button>
            </div>

        </div>
    </div>`;

    activatePopUp(scanHtml);
    
    // Wacht tot de modal écht zichtbaar is voor animatie start
    const modalEl = document.querySelector('.custom-modal');

    waitUntilVisible(modalEl, () => {
        initScanProgressAnimation();
    });
}

function createProgressRow(key, label) {
    return `
        <div class="co-scan-modal__progress-row" data-co-scan-row="${key}">
            <span class="co-scan-modal__progress-label">${label}</span>
            <div class="co-scan-modal__progress-bar">
                <div class="co-scan-modal__progress-bar-fill" data-co-scan-progress-fill="${key}"></div>
                <div class="co-scan-modal__progress-bar-icon" data-co-scan-progress-icon="${key}"></div>
            </div>
        </div>
    `;
}

function initScanProgressAnimation() {
    const modalEl = document.querySelector('.custom-modal');
    if (!modalEl) return;

    const titleEl = modalEl.querySelector('[data-co-scan-title]');
    const subtitleEl = modalEl.querySelector('[data-co-scan-subtitle]');

    if (titleEl) titleEl.textContent = "Voertuig scannen...";
    if (subtitleEl) subtitleEl.textContent = "Bezig met scannen";

    // Nieuwe timings, geschaald zodat de laatste stap ≈ 2500ms is
    const animationPlan = {
        kenteken: [
            { t: 80,  p: 30 },
            { t: 250, p: 75 },
            { t: 750, p: 100 }
        ],
        bouwjaar: [
            { t: 80,  p: 20 },
            { t: 330, p: 60 },
            { t: 1000, p: 100 }
        ],
        scherm: [
            { t: 130,  p: 18 },
            { t: 580,  p: 62 },
            { t: 1330, p: 100 }
        ],
        canbus: [
            { t: 170,  p: 15 },
            { t: 670,  p: 55 },
            { t: 1170, p: 80 },
            { t: 1800, p: 100 }
        ]
    };

    // Alle progress-steps plannen
    Object.keys(animationPlan).forEach(key => {
        const steps = animationPlan[key];
        const fill = modalEl.querySelector(`[data-co-scan-progress-fill="${key}"]`);
        const icon = modalEl.querySelector(`[data-co-scan-progress-icon="${key}"]`);
        const row  = modalEl.querySelector(`[data-co-scan-row="${key}"]`);

        if (!fill || !icon || !row) return;

        steps.forEach(step => {
            setTimeout(() => {
                if (!document.body.contains(fill)) return;

                fill.style.width = step.p + "%";

                if (step.p >= 100) {
                    icon.classList.add("co-scan-modal__progress-bar-icon--complete");
                    row.classList.add("co-scan-modal__progress-row--ready");
                }
            }, step.t);
        });
    });

    // Bepaal het moment van de laatste stap (max t)
    let lastTime = 0;
    Object.keys(animationPlan).forEach(key => {
        animationPlan[key].forEach(step => {
            if (step.t > lastTime) lastTime = step.t;
        });
    });

    // Direct NA de laatste 100% stap: Auto gematched + check-animatie
    setTimeout(() => {
        if (!document.body.contains(modalEl)) return;

        if (titleEl) titleEl.textContent = "Auto Geschikt!";
        if (subtitleEl) {
            subtitleEl.textContent = "100% Geschikt voor CarPlay and Android Auto";
        }

        const imgInner = modalEl.querySelector(".co-scan-modal__image-inner");
        if (imgInner) imgInner.classList.add("co-scan-modal__image-inner--done");

        const check = modalEl.querySelector(".co-scan-check-field__checkbox");
        if (check) check.checked = true;

    }, lastTime + 500); // klein beetje marge voor smoothness
}


window.__SCAN_CHECK_SVG__ = `
    <svg class="co-scan-check" viewBox="0 0 64 64" aria-hidden="true"> 
        <g transform="translate(32,32)"> <g stroke-linecap="round" stroke-width="3"> <polyline class="co-scan-check__stroke-offset co-scan-check__stroke-offset--1" stroke="var(--co-scan-purple)" points="-30 -30,-42 -42" stroke-dasharray="17 17" stroke-dashoffset="17" /> <polyline class="co-scan-check__stroke-offset co-scan-check__stroke-offset--2" stroke="var(--co-scan-primary)" points="38 -38,54 -54" stroke-dasharray="22.63 22.63" stroke-dashoffset="22.63" /> <polyline class="co-scan-check__stroke-offset co-scan-check__stroke-offset--3" stroke="var(--co-scan-green)" points="-28 28,-40 40" stroke-dasharray="17 17" stroke-dashoffset="17" /> <polyline class="co-scan-check__stroke-offset co-scan-check__stroke-offset--4" stroke="var(--co-scan-red)" points="32 32,44 44" stroke-dasharray="17 17" stroke-dashoffset="17" /> </g> <g> <circle class="co-scan-check__move-fade co-scan-check__move-fade--1" fill="var(--co-scan-red)" r="3" cx="4" cy="-44" opacity="0" /> <circle class="co-scan-check__move-fade co-scan-check__move-fade--2" fill="var(--co-scan-primary)" r="3" cx="-44" cy="-8" opacity="0" /> <circle class="co-scan-check__move-fade co-scan-check__move-fade--3" fill="var(--co-scan-green)" r="3" cx="52" cy="12" opacity="0" /> <circle class="co-scan-check__move-fade co-scan-check__move-fade--4" fill="var(--co-scan-purple)" r="2" cx="-2" cy="40" opacity="0" /> <circle class="co-scan-check__move-fade co-scan-check__move-fade--5" fill="var(--co-scan-primary)" r="3" cx="-12" cy="46" opacity="0" /> </g> <g class="co-scan-check__scale-out" fill="none" stroke="var(--co-scan-check-outline)" stroke-width="2"> <circle r="30" /> <polygon points="-10 -4,-16 2,-4 14,16 -6,10 -12,-4 2" /> </g> <g class="co-scan-check__fade" opacity="0"> <circle class="co-scan-check__scale-in co-scan-check__scale-in--1" fill="var(--co-scan-check-bubble)" r="30.9" /> <circle class="co-scan-check__scale-in co-scan-check__scale-in--2" fill="var(--co-scan-primary)" r="31" /> <polygon class="co-scan-check__scale-in co-scan-check__scale-in--3" fill="var(--co-scan-white)" stroke="var(--co-scan-primary)" stroke-width="2" points="-10 -4,-16 2,-4 14,16 -6,10 -12,-4 2" /> </g> </g>
    </svg>
`;
